<template>
    <div>
        <!-- 吸顶导航 -->
        <van-sticky>
            <van-nav-bar style="background-color: #3f78f6; margin-bottom: 0rem;border:0" title="" left-text=""
                left-arrow @click-left="onClickLeft">
                <template #title>
                    <span style="color: white;font-size: .4rem;">未归回复</span>
                </template>
                <template #left>
                    <van-icon name="arrow-left" color="white" size="18" />
                </template>
            </van-nav-bar>
        </van-sticky>
        <van-form class="van-form" style="margin-top:20px" @submit="onSubmit">
            <van-field v-model="backContent" label="回复内容" name="backContent" placeholder="请输回复内容"
                :rules="[{ required: true, message: '请输回复内容' }]" type="textarea" rows="10" />
            <div style="margin: 16px;margin-top:40px">
                <van-button round block type="info" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                backContent: "",
                shenfen: "",
                id: "",
                page: "",
                student: ""
            };
        },
        created() {
            this.shenfen = this.$route.query.shenfen;
            this.id = this.$route.query.id;
            this.backContent = this.$route.query.backContent;
            this.page = this.$route.query.page;
            this.student = this.$route.query.student;
            console.log(this.shenfen + this.id + this.backContent);
        },
        methods: {
            onSubmit(values) {
                console.log("submit", values);
                var params_json = {
                    userid: "",
                    action: "noticeBack",
                    param1: this.id,
                    param2: values.backContent,
                    param3: this.shenfen,
                    param4: "",
                    param5: ""
                };
                this.$http
                    .post("/web/save", params_json)
                    .then(function (res) {
                        let obj = res.data;
                        if (obj.msg == "0") {
                            this.$notify({
                                type: "success",
                                message: "回复成功。"
                            });
                            setTimeout(() => {
                                this.$router.push({
                                    path: "WeChat",
                                    query: {
                                        page: this.page,
                                        student: this.student
                                    }
                                });
                            }, 1000);
                        } else {
                            this.$notify({
                                type: "warning",
                                message: obj.msg
                            });
                        }
                    });
            },
            onClickLeft() {
                this.$router.push({
                    path: "WeChat",
                    query: {
                        page: this.page,
                        student: this.student
                    }
                });
            },
            onClickRight() {
                // 危险通知
                this.$toast("失败文案");
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .van-doc-demo-block__title {
        margin: 0;
        padding: 32px 16px 16px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
    }

    .van-doc-demo-block__card {
        margin: 12px 12px 0;
        overflow: hidden;
        border-radius: 8px;
    }

    .van-doc-demo-block__title+.van-doc-demo-block__card {
        margin-top: 0;
    }

    .van-doc-demo-block:first-of-type .van-doc-demo-block__title {
        padding-top: 20px;
    }
</style>
<style>
    .demo-col {
        background: #fff;
    }

    .demo-col .van-doc-demo-block {
        padding: 0 16px;
    }

    .demo-col .van-doc-demo-block__title {
        padding-left: 0;
    }

    .demo-col .van-col {
        margin-bottom: 10px;
        color: #fff;
        font-size: 13px;
        line-height: 30px;
        text-align: center;
        background-clip: content-box;
    }

    .demo-col .van-col:nth-child(odd) {
        background-color: #39a9ed;
    }

    .demo-col .van-col:nth-child(even) {
        background-color: #66c6f2;
    }
</style>